/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import ChangeSchedulestatus from "../ChangeScheduleStatusPopup/ChangeScheduleStatusPopUp.vue";
import ChangeactivityStatusPopup from "../ChangeactivityStatusPopup/ChangeactivityStatusPopup.vue"
import AssignEproPopup from "../AssignEproPopup/AssignEproPopup.vue";
import CreateVideoCallSchedulePopUp from "../../components/CreateVideoCallSchedulePopUp/CreateVideoCallSchedulePopUp.vue";
import AssignFormSdvModal from "../AssignFormSdvModal/AssignFormSdvModal.vue";
import CreateScheduleCyclePopUp from "../../components/ScheduleCyclePopup/ScheduleCyclePopup.vue";
import ManageCyclePopup from "../../components/ManageCyclePopup/ManageCyclePopup.vue";
import ChangeCycleStatusPopUp from "../../components/CycleStatusPopUp/ChangeCycleStatusPopUp.vue";
import changeplanneddatePopup from "../../components/changeplanneddatePopup/changeplanneddatePopup.vue"
import mapformmodel from "../mapformmodel/mapformmodel.vue";
import customModal from "../customModal/customModal.vue";
import ManageVisit from "../../components/ManageVisit/ManageVisit.vue";
import UnscheduledVisitModal from "../../components/UnscheduledVisitModal/UnscheduledVisitModal.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    VPagination,
    ChangeSchedulestatus,
    AssignEproPopup,
    CreateVideoCallSchedulePopUp,
    ChangeactivityStatusPopup,
    AssignFormSdvModal,
    CreateScheduleCyclePopUp,
    ManageCyclePopup,
    ChangeCycleStatusPopUp,
    changeplanneddatePopup,
    mapformmodel,
    customModal,
    flatPickr,
    ManageVisit,
    UnscheduledVisitModal
  },
  props: {
    subjectId: String,
  },
  data() {
    return {
      dateTimePickerConfig: {
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d\\TH:i",
        allowInput: true
      },
      plannedvisitobject:{},
      showManageVisitModal:false,
      showUnscheduledVisitModal:false,
      patientId:"",
      subjectname:"",
      showformmodelpopup:false,
      plannextvisitPopup:false,
      oldvisitdatetDate:"",
      newvisitDate:"",
      preVisitDate:"",
      postVisitDate:"",
      currentformid:"",
      currentRecentEcrfformPage: 1,
      selectedScheduleId:"",
      activitystatusreload:{},
      managevisitobj:{},
      actualVisitStartDate:"",
      actualVisitEndDate:"",
      isCompleted:false,
      currentactivitystatus: "",
      selectedActivityid: "",
      temptemplatelist: [],
      showChangeTemplateModal: false,
      plannedvisitpopup: false,
      FillForm: "FillForm",
      sProp: "",
      scheduleId: "",
      IsDesc: true,
      defaultdate: "",
      roleprivileges: "",
      baseapi: process.env.VUE_APP_Service_URL,
      localurl: process.env.VUE_APP_redirect,
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/patientschedule/`,
      currentTemplatePage: 1,
      totalTemplatePages: 1,
      plannedvisits: [],
      sites: [],
      pageplannedindex: 1,
      pageplannedsize: 10,
      recentpageplannedsize: 10,
      currentplannedPage: 1,
      totalplannedCount: 0,
      totalrecentCount: 0,
      totalplannedPages: 0,
      pageoverdueindex: 1,
      pageoverduesize: 10,
      currentoverduePage: 1,
      totaloverdueCount: 0,
      totaloverduePages: 0,
      pageformindex: 1,
      pageformsize: 10,
      currentformPage: 1,
      totalformCount: 0,
      totalformPages: 0,
      patientLists: [],
      recentformList: [],
      recentecrfList: [],
      visitobj: {},
      visitTreeObj: {},
      hasadditionalforms:{},
      currentRecentformPage: 1,
      totalformsPages: 0,
      recentpageformindex: 1,
      recentpageformsize: 10,
      recentFormsPageSize: 15,
      recentFormsLoading: false,
      SortProperty: "",
      SortOrder: 1,
      investigatorEmail: "",
      subjectIdSelected: "",
      showSidePopup: [[[false]]],
      templateList: [],
      visitFormObj: {},
      additionalFormObj:{},
      activityobject: {},
      observationValue: {},
      selectedVisit: {},
      selectedTemplate: "",
      sohowFormModal: false,
      sohowFormModalImminent: false,
      showChangeSchedule: false,
      showChangeActivity: false,
      showSdvModal: false,
      templateIdForSdv: null,
      formlist: [],
      CreateVideoCallSchedulePopUp: false,
      CreateScheduleCyclePopUp: false,
      ManageScheduleCyclePopUp: false,
      ChangeCycleStatusPopUp: false,
      selectedCycleId: null,
      selectedOccurrence: null,
      showCycleSidePopup: {},
      selectedPatientId: null,
      statusType: "",
      changeStatus: {
        studyId: "",
        visitNo: "",
        subjectNo: "",
        visitstatus: "",
      },
      changetemplateobj: {
        studyId: "",
        visitNo: "",
        subjectNo: "",
        visitstatus: "",
      },
      visitIndex: "",
      showObservationsLoading: {},
      categoryFlags: {},
      studyRef: null,
      selectedForm: "",
      studyInfo: "",
      selectedVisitName: "",
      formIndex: "",
      scheduleId: "",
      selectedFormScope: "",
      openedsitesarray: [],
      openedpatientsarray: [],
      openedformsarray: [],
      selectedPatientId: "",
      selectedVisitNo: "",
      showChangeTemplatePopover: false,
      vIndex: "",
      showChangeTemplatePopover: "",
      selectedSiteCode: "",
      selectedPatno: "",
      showAssignForm: false,
      showAssignTemplate: false,
      ecrfformlist: [],
      referanceType: "",
      occuranceStartDate: "",
      totalOccurance: 0,
      templateName: "",
      templateId: "",
      additionalFormObj: {},
      hasadditionalforms: {},
      expandedAdditionalGroups: {},
      expandedAdditionalMain: {},
      additionalformchecked:{},
      createvisitobj:{},
      ManageVisitPopup:false,
      tempSchedule:{},
      showLoader: false,
      showCreateLoader: false,
      formsLoader: true,
      activeRightTab: "pending",
      pendingFormList: [],
      currentPendingFormPage: 1,
      totalPendingFormsPages: 0,
      pendingFormsLoading: false,
      pendingFormsLoaded: false,
    };
  },
computed: {
    // Grouped additional forms: { patientId: { templateId: { name, forms[] } } }
    groupedAdditionalForms() {
      const grouped = {};
      
      for (const patientId in this.additionalFormObj) {
        const forms = this.additionalFormObj[patientId] || [];
        const byTemplate = {};

        forms.forEach(form => {
          const key = form.templateId;
          if (!byTemplate[key]) {
            byTemplate[key] = {
              templateName: form.templateName,
              forms: []
            };
          }
          byTemplate[key].forms.push(form);
        });

        grouped[patientId] = byTemplate;
      }

      return grouped;
    }
  },
  async mounted() {
    this.formsLoader = true;
    this.getsubjectdetails();
    this.listPendingVisitForms(1);
    this.defaultdate = localStorage.getItem("dateformat");
    window.addEventListener("studyIdChanged", (event) => {
      //this.listEcrfForms();
      if (this.activeRightTab === "pending") {
        this.listPendingVisitForms(1);
      }
      this.getSubjectTemplates();
      // this.listtemplate();
    });
    await this.setroleprivileges();
    this.listEcrfForms();
    await this.getSubjectTemplates();
    // this.listtemplate();
    //this.listrecentvisitForms();
    this.investigatorEmail = jwt_decode(store.getters.getIdToken);
    const el = this.$refs[this.subjectId];
    if (el) {
      el.click();
    }

  },
  unmounted() {
    store.dispatch("setopentreeforsubjectschedule", false);
  },
  methods: {
    async onCycleScheduled() {
      await this.getVisits(this.subjectId, 0);
    },
    setRightTab(tab) {
      this.activeRightTab = tab;
      if (tab === "pending" && !this.pendingFormsLoaded) {
        this.listPendingVisitForms(1);
      }
    },
    showPopover(id) {
      document.getElementById(id)?.showPopover?.();
    },
    hidePopover(id) {
      document.getElementById(id)?.hidePopover?.();
    },
    //subjectname
    async getsubjectdetails(){
    const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/management/patient/getpatientbyid/` + this.subjectId, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => (this.subjectname = res.data.subjectId))
        .catch((err) => console.log(err));
    },
    toggleAdditionalMain(patientId) {
    // Toggle the main folder
    this.expandedAdditionalMain = {
      ...this.expandedAdditionalMain,
      [patientId]: !this.expandedAdditionalMain[patientId]
    };

    // If opening, load data if not already loaded
    if (!this.expandedAdditionalMain[patientId] === false) { // i.e., now opening
      if (!this.additionalFormObj[patientId]) {
        this.getAdditionalForms(patientId);
      }
    }

    // Optional: collapse all sub-groups when closing main
    if (!this.expandedAdditionalMain[patientId]) {
      this.expandedAdditionalGroups = {
        ...this.expandedAdditionalGroups,
        [patientId]: {} // clear all sub-expansions
      };
    }
  },
    toggleAdditionalGroup(patientId, templateId) {
    // Create a fresh copy to trigger reactivity
    const patientGroups = { 
      ...(this.expandedAdditionalGroups[patientId] || {}) 
    };

    // Toggle the value
    patientGroups[templateId] = !patientGroups[templateId];

    // Reassign the entire patient object — this forces Vue to react
    this.expandedAdditionalGroups = {
      ...this.expandedAdditionalGroups,
      [patientId]: patientGroups
    };
  },


async waitForCheckboxAndCheck(id) {
  await this.waitForElement(`#${CSS.escape(id)}`).catch(() => {});
  const el = document.getElementById(id);
  if (el && !el.checked) el.checked = true; // expand for CSS tree
},
findActivityIndex(subjectId, visitNo, visitIndex, activityid, activityorder) {
  const key = `${visitNo}_${subjectId}`;
  const arr = (this.activityobject[key]?.[visitIndex]?.data) || [];
  return arr.findIndex(a => a.activityId === activityid && a.activityOrder === activityorder);
},
  async restoreforms() {
  const opened = store.getters.getopenedformsarraysubschedule || [];
  if (!opened.length) return;

  // 1) Ensure visits (and activities) are loaded & expanded
  const visitEntries = opened.filter(x => !x.activityid);
  for (const e of visitEntries) {
    const visitCbId = `${e.sheduleId}${e.subjectId}`; // matches :id="visit.sheduleId + patient.patientId"
    await this.waitForCheckboxAndCheck(visitCbId);

    // Load activities for this visit
    await this.getactivities(e.subjectId, e.visitNo, e.visitName, e.visitIndex, e.sheduleId);
    await this.$nextTick();
  }

  // 2) Expand the specific activities and fetch their forms
  const activityEntries = opened.filter(x => x.activityid);
  for (const e of activityEntries) {
    const visitKey = `${e.visitNo}_${e.subjectId}`;

    // Make sure activities are present for this visit
    if (!this.activityobject[visitKey] || !this.activityobject[visitKey][e.visitIndex]) {
      await this.getactivities(e.subjectId, e.visitNo, e.visitName, e.visitIndex, e.sheduleId);
      await this.$nextTick();
    }

    const idx = this.findActivityIndex(e.subjectId, e.visitNo, e.visitIndex, e.activityid, e.activityorder);

    // Expand the activity branch (CSS checkbox)
    const activityCbId = `${e.activityid}${e.visitNo}${e.activityorder}`;
    await this.waitForCheckboxAndCheck(activityCbId);

    // Load forms under this activity
    await this.getFormsByVisit(
      e.subjectId,
      e.visitNo,
      e.visitName,
      e.visitIndex,
      e.sheduleId,
      idx < 0 ? 0 : idx,
      e.activityid,
      e.activityorder
    );

    await this.$nextTick();
  }
},
   waitForElement(selector, timeout = 4000) {
  return new Promise((resolve, reject) => {
    const start = performance.now();
    const check = () => {
      if (document.querySelector(selector)) return resolve();
      if (performance.now() - start > timeout) return reject(new Error(`Element ${selector} not found`));
      requestAnimationFrame(check);
    };
    check();
  });
},
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    async openFormsModal(visitNo, patientId, studyId) {
      await this.listvisitForms(visitNo, patientId, studyId);
      this.sohowFormModal = true;
    },
    async openImminentFormsModal(visitNo, patientId, studyId) {
      await this.listvisitForms(visitNo, patientId, studyId);
      this.sohowFormModalImminent = true;
    },
    async closeFormsModal() {
      this.sohowFormModal = false;
    },
    async closeImminentFormsModal() {
      this.sohowFormModalImminent = false;
    },
    openVideoCallSchedulePopup(patientId) {
      this.selectedPatientId = patientId; // Set the selected patient ID
      console.log("Patient id is", this.selectedPatientId);
      this.CreateVideoCallSchedulePopUp = true; // Open the popup
    },
    openScheduleCyclePopup(cycleId, patientId) {
      this.selectedPatientId = patientId; // Set the selected patient ID
      this.selectedCycleId = cycleId; // Set the selected cycle ID
      this.CreateScheduleCyclePopUp = true; // Open the popup
    },
    openManageCyclePopup(cycleId, patientId, occurence) {
      this.selectedPatientId = patientId;
      this.selectedCycleId = cycleId;
      this.selectedOccurrence = occurence;
      this.ManageScheduleCyclePopUp = true;
    },
    openCycleStatusUpdatePopup(cycleId, occurrence, patientId) {
      this.selectedPatientId = patientId;
      this.selectedCycleId = cycleId;
      this.selectedOccurrence = occurrence;
      this.ChangeCycleStatusPopUp = true;
    },
    toggleCycleSidePopup(nodeIndex) {
      if (!this.showCycleSidePopup[0]) {
        this.showCycleSidePopup[0] = {};
      }
      this.showCycleSidePopup[0][nodeIndex] = !this.showCycleSidePopup[0][nodeIndex];
    },
    closeCycleSidePopup(nodeIndex) {
      if (this.showCycleSidePopup[0]) {
        this.showCycleSidePopup[0][nodeIndex] = false;
      }
    },
    formatdatetime(input) {
            if (!input) return "";

            const dateObj = new Date(input);

            if (isNaN(dateObj.getTime())) return "";

            return dateObj.toLocaleString();
        },
    async openAssignFormModal(patientId, visitName, visitNo, vIndex, sheduleId, siteCode, patientNo) {
      this.selectedPatientId = patientId;
      this.selectedVisitName = visitName;
      this.selectedVisitNo = visitNo;
      this.vIndex = vIndex;
      this.selectedScheduleId = sheduleId;
      this.selectedSiteCode = siteCode;
      this.selectedPatno = patientNo;
      this.showAssignForm = true;
      await this.getEPROFormsList();
    },
    async closeAssignFormModal() {
      this.showAssignForm = false;
      await this.getFormsByVisit(this.selectedPatientId, this.selectedVisitNo, this.selectedVisitName, this.vIndex, this.selectedScheduleId, this.selectedSiteCode, this.selectedPatno);
    },
    // async viewForm(formId, isPatientVisit) {
    //   this.$router.push(`/editForm/submitForm/${formId}/${isPatientVisit}`);
    // },
    // async listtemplate() {
    //   const idtoken = store.getters.getIdToken;
    //   try {
    //     const response = await axios.get(
    //       `${this.baseUrl}/forms/template/listtemplate?StudyId=${store.getters.getStudyIs}`,
    //       {
    //   headers: {
    //     Authorization: "Bearer " + idtoken,
    //     "Content-Type": "application/json",
    //   },
    //       }
    //     );
    //     if (response.data && response.data.results) {
    //       console.log("response.data", response.data);
    //       // Map results to include dynamic form scope
    //       this.scheduledarray = response.data.results.map(template => ({
    //   ...template,
    //   form_Scope: template.form_Scope || "Subject Level" // Use from response or default
    //       }));
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    //    },
   
    async listEcrfForms(pageNo = 1) {
      const studyId = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      const itemCount = this.recentFormsPageSize;

      this.recentFormsLoading = true;

      try {
      const res = await axios.get(`${this.baseapi}/forms/forms/listecrf`, {
        params: {
          FormName : this.selectedFormScope,
          StudyId: studyId,
          PatientId: this.subjectId,
          FormScope: "Subject Level",
          pageindex: pageNo,
          pagesize: itemCount,
          SortProperty: this.SortProperty || "formName",
          SortOrder: this.SortOrder || "0",
          VisitNo: ""
        },
        headers: {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
        },
      });

      console.log("API response:", res.data);

      const totalCount = res.data?.totalCount || 0;
      this.recentecrfList = Array.isArray(res.data?.results) ? res.data.results : [];

      // normalize helper
      const normalize = (s) =>
        String(s || "")
        .trim()
        .replace(/\s+/g, " ")
        .toLowerCase();

      const running = Object.create(null);

      this.recentecrfList = this.recentecrfList.map((item) => {
        const original = String(item.formName || "").trim();
        const key = normalize(original);

        if (!key) {
        return { ...item, formNameDisplay: "(1) -" };
        }

        running[key] = (running[key] || 0) + 1;

        return {
        ...item,
        formNameDisplay: `(${running[key]}) ${original}`,
        };
      });

      this.totalformsPages =
        totalCount > 0 ? Math.ceil(totalCount / itemCount) : 0;

      if (
        this.totalformsPages > 0 &&
        this.currentRecentEcrfformPage > this.totalformsPages
      ) {
        this.currentRecentEcrfformPage = this.totalformsPages;
      }
        this.formsLoader = false;
      } catch (err) {
        console.log("error in getting visit forms...", err);
        this.formsLoader = false
        this.recentecrfList = [];
        this.totalformsPages = 0;
      } finally {
        this.formsLoader = false;
        this.recentFormsLoading = false;
      }
    },

    async listPendingVisitForms(pageNo = 1) {
      const studyId = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      const visitNo = "";
      const itemCount = this.recentFormsPageSize;

      this.pendingFormsLoading = true;
      try {
        const res = await axios.get(
          `${this.baseapi}/forms/forms/formlisthavingnullvisit` +
            `?StudyId=${encodeURIComponent(studyId)}` +
            `&PatientId=${encodeURIComponent(this.subjectId)}` +
            `&pageindex=${encodeURIComponent(pageNo)}` +
            `&pagesize=${encodeURIComponent(itemCount)}` +
            `&FormScope=Visit Level`+
            `&SortProperty=${encodeURIComponent(this.SortProperty || "formName")}` +
            `&SortOrder=${encodeURIComponent(this.SortOrder || "0")}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const totalCount = res.data?.totalCount || 0;
        this.pendingFormList = Array.isArray(res.data?.results) ? res.data.results : [];

        const normalize = (s) =>
          String(s || "")
            .trim()
            .replace(/\s+/g, " ")
            .toLowerCase();

        const running = Object.create(null);

        this.pendingFormList = this.pendingFormList.map((item) => {
          const original = String(item.formName || "").trim();
          const key = normalize(original);

          if (!key) {
            return { ...item, formNameDisplay: "(1) -" };
          }

          running[key] = (running[key] || 0) + 1;

          return {
            ...item,
            formNameDisplay: `(${running[key]}) ${original}`,
          };
        });

        this.totalPendingFormsPages =
          totalCount > 0 ? Math.ceil(totalCount / itemCount) : 0;

        if (
          this.totalPendingFormsPages > 0 &&
          this.currentPendingFormPage > this.totalPendingFormsPages
        ) {
          this.currentPendingFormPage = this.totalPendingFormsPages;
        }
        this.pendingFormsLoaded = true;
      } catch (err) {
        console.log(" error in getting pending visit forms...", err);
        this.pendingFormList = [];
        this.totalPendingFormsPages = 0;
      } finally {
        this.pendingFormsLoading = false;
      }
    },

//      async listrecentvisitForms(pageNo = 1) {
//     const studyId = store.getters.getStudyIs;
//     const idtoken = store.getters.getIdToken;

//     // If your API expects empty instead of "null", use "" instead of null
//     const visitNo = "";

//     const itemCount = this.recentFormsPageSize;

//     this.recentFormsLoading = true;
//     try {
//       const res = await axios.get(
//         `${this.baseapi}/forms/forms/formlisthavingnullvisit` +
//           `?StudyId=${encodeURIComponent(studyId)}` +
//           `&PatientId=${encodeURIComponent(this.subjectId)}` +
//           `&VisitNo=${encodeURIComponent(visitNo)}` +
//           `&SortProperty=formName` +
//           `&pageindex=${encodeURIComponent(pageNo)}` +
//           `&pagesize=${encodeURIComponent(itemCount)}`+
//           `&SortProperty=${this.SortProperty}`+
//           `&SortOrder=${this.SortOrder}`,
//         {
//           headers: {
//             Authorization: "Bearer " + idtoken,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       this.recentformList = [];
//       const totalCount = res.data.totalCount;
//       this.recentformList = Array.isArray(res.data?.results) ? res.data.results : [];

// // normalize helper (handles case & spaces)
// const normalize = (s) =>
//   String(s || "")
//     .trim()
//     .replace(/\s+/g, " ")
//     .toLowerCase();

// // running index PER form name
// const running = Object.create(null);

// this.recentformList = this.recentformList.map((item) => {
//   const original = String(item.formName || "").trim();
//   const key = normalize(original);

//   if (!key) {
//     return { ...item, formNameDisplay: "(1) -" };
//   }

//   running[key] = (running[key] || 0) + 1;

//   return {
//     ...item,
//     formNameDisplay: `(${running[key]}) ${original}`,
//   };
// });
//       this.totalformsPages = totalCount > 0 ? Math.ceil(totalCount / itemCount) : 0;

//       // safety: if current page is now out of range, pull it back
//       if (this.totalformsPages > 0 && this.currentRecentformPage > this.totalformsPages) {
//         this.currentRecentformPage = this.totalformsPages;
//       }
//     } catch (err) {
//       console.log(" error in getting visit forms...", err);
//       this.recentformList = [];
//       this.totalformsPages = 0;
//     } finally {
//       this.recentFormsLoading = false;
//     }
//   },
  async onFormMapped() {
    // reload pending visit forms
    await this.listPendingVisitForms(this.currentPendingFormPage || 1);
  },

    async gotoform(singlevisit, autosubjectid) {
      let autositecode = singlevisit.siteId;
      if (singlevisit.visitStatus == "Withdrawn") {
        alert("The form has already been withdrawn.");
      } else {
        console.log("singlevisit", singlevisit);
        await store.dispatch("setautofillsiteid", autositecode);
        await store.dispatch("setautofillsubjectid", autosubjectid);
        await store.dispatch("setautofillenabled", "true");
        if (singlevisit.formId == null || singlevisit.formId == "") {
          let tempvar = {
            Siteid: singlevisit.siteId,
            Subject_id: singlevisit.patientId,
            Visitname: singlevisit.visitName,
            Visitno: singlevisit.visitNo,
            sheduleId: singlevisit.sheduleId,
          };
          await store.dispatch("commitvisitdetails", tempvar);
          console.log("IspatientVist?", singlevisit.isPatientVisit);
          if (singlevisit.templateId == null || singlevisit.templateId == "") {
            alert(this.$t("navigations.no template assigned"));
          } else {
            this.$router.push(
              `/form/${singlevisit.isPatientVisit}/${singlevisit.templateId}/${singlevisit.studyId}/0 `
            );
          }

          // this.$router.push(`/form/${visits.templateId}/${visits.studyId}/${visits.visitid}`);
        } else {
          this.$router.push(
            `/editForm/subject_tree/${singlevisit.formId}/${singlevisit.isPatientVisit} `
          );
        }
      }
    },
    async gotofillform(visits, autosubjectid, autositecode) {
      if (!this.selectedTemplate) {
        alert("Please select a form.");
        return;
      }
      console.log("gotofillform visits", visits);
      await store.dispatch("setautofillsiteid", autositecode);
      await store.dispatch("setautofillsubjectid", autosubjectid);
      await store.dispatch("setautofillenabled", "true");
      const template = this.templateList.find(
        (t) => t.templateId === this.selectedTemplate
      );
      let tempvar = {
        Siteid: visits.siteId,
        Subject_id: this.subjectIdSelected,
        Visitname: visits.visitName,
        Visitno: visits.visitNo,
        sheduleId: visits.sheduleId,
        Template_name: template.templateName,
        Visit_id: visits.visitId,
        ActivityScheduleId: visits.actScheduleId,
        ActivityId: visits.activityId,
      };
      await store.dispatch("commitvisitdetails", tempvar);
      localStorage.setItem("visitDetails", JSON.stringify(tempvar));
      console.log("tempvar is ", tempvar);
      await store.dispatch("setfrompatientschedule", "frompatientschedule");
      this.$router.push({
        path: `/form/${visits.isPatientVisit}/${this.selectedTemplate}/${visits.studyId}/0`,
        query: {
          tempObj: encodeURIComponent(JSON.stringify(tempvar)),
        },
      });
    },
    async goToForms() {
      if (visits.formId == null || visits.formId == "") {
        this.gotoform();
      } else {
        this.EditForm();
      }
    },
    async EditForm(formId, isPatientVisit) {
      this.$router.push(`/editForm/subject_schedule/${formId}/${isPatientVisit}`);
    },
    async goTovisitTemplate(lists, patientId) {
      if (lists[0].visitStatus == "Withdrawn") {
        alert("The form has already been withdrawn.");
      } else {
        localStorage.setItem("patid", patientId);
        console.log("List visit is ", lists);
        console.log("TEMPLATE ID IS", await lists[0].templateId, await lists);
        await store.dispatch("setautofillsiteid", lists[0].siteCode);
        await store.dispatch("setautofillsubjectid", lists[0].patientNo);
        await store.dispatch("setautofillenabled", "true");
        if (
          ((await lists[0].templateId) != null &&
            (await lists[0].templateId) != "null" &&
            (await lists[0].formId) == null) ||
          (await lists[0].formId) == "null"
        ) {
          let tempvar = {
            Siteid: lists[0].siteId,
            Subject_id: lists[0].patientId,
            Visitname: lists[0].visitName,
            Visitno: lists[0].visitNo,
            sheduleId: lists[0].sheduleId,
          };

          await store.dispatch("commitvisitdetails", tempvar);
          this.$router.push(
            `/form/${lists[0].isPatientVisit}/${lists[0].templateId}/${lists[0].studyId}/0 `
          );
        } else if (
          (await lists[0].templateId) != null &&
          (await lists[0].templateId) != "null" &&
          (await lists[0].formId) != null &&
          (await lists[0].formId) != "null"
        ) {
          this.$router.push(
            `/editForm/subject_schedule/${lists[0].formId}/${lists[0].isPatientVisit} `
          );
        } else if (
          (await lists[0].templateId) == null ||
          (await lists[0].templateId) == "null"
        ) {
          alert(this.$t("navigations.no template assigned"));
        }
      }
    },
    async goToTemplate(isPatientVisit, templateid, visitid) {
      await store.dispatch("setautofillsiteid", "");
      await store.dispatch("setautofillsubjectid", "");
      await store.dispatch("setautofillenabled", "false");
      const studyid = store.getters.getStudyIs;
      this.$router.push(
        `/form/${isPatientVisit}/${templateid}/${studyid}/${visitid}`
      );
    },
    async isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async viewform(id, siteid, subid,sheduleId ) {
      this.selectedScheduleId=sheduleId;
      console.log("siteid, subid = ", siteid, subid);
      if (siteid != null || subid != null) {
        console.log("siteid, subid = ", siteid, subid);
        await store.dispatch("setautofillenabled", "true");
      } else {
        await store.dispatch("setautofillenabled", "false");
      }
      // this.$router.push(`/showform/subject_schedule/${id}/0`);
      this.currentformid=id;

       this.showformmodelpopup=true;
       
    
    },
    async setFontSize(el) {
      var fontSize = el.val();

      if (isNumber(fontSize) && fontSize >= 0.5) {
        $("body").css({ fontSize: fontSize + "em" });
      } else if (fontSize) {
        el.val("1");
        $("body").css({ fontSize: "1em" });
      }
    },
    async itemClick(node) {
      console.log(node.model.text + " clicked !");
    },

    filter(data) {
      if (data) {
        return moment(data)
          .utc()
          .format(this.defaultdate);
      }
      console.log(data);
    },
    filterMonth(date) {
      if (date) {
        //console.log("dateeeeeeeeee",date)
        return moment(date).format("DD-MMM-YYYY");
      }
    },
    filterCalander(date) {
      if (date) {
        return moment(date).format("YYYY-MM-DD hh:mm A");
      }
    },
    SortSelectforms(sortProp, id) {
      console.log("SortPropChanged"); 
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc;
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortDesc")) {
            return;
          } else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else if (selectedElement.classList.contains("sortAsc")) {
            return;
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == 0 ? 1 : 0;
      if (this.activeRightTab === "pending") {
        this.currentPendingFormPage = 1;
        this.listPendingVisitForms(1);
      } else {
        this.currentRecentEcrfformPage = 1;
        this.listEcrfForms(1);
      }
    },
    async GetRecentFormData() {
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/forms/ecrfsource/getpaginatedrecentecrf?studyId=${stdid}&pageindex=${this.recentpageformindex}&pagesize=${this.recentpageformsize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data) {
            console.log("study id iSssssssssss", stdid);
            // this.recentformList = response.data.results;
            this.recentformList = Array.isArray(res.data?.results) ? res.data.results : [];

// normalize helper (handles case & spaces)
const normalize = (s) =>
  String(s || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

// running index PER form name
const running = Object.create(null);

this.recentformList = this.recentformList.map((item) => {
  const original = String(item.formName || "").trim();
  const key = normalize(original);

  if (!key) {
    return { ...item, formNameDisplay: "(1) -" };
  }

  running[key] = (running[key] || 0) + 1;

  return {
    ...item,
    formNameDisplay: `(${running[key]}) ${original}`,
  };
});
            console.log("Recent form table data", response.data);
            this.totalrecentCount = response.data.totalCount;
            this.totalformsPages = parseInt(
              this.totalrecentCount / this.recentpageplannedsize
            );
            if (this.totalrecentCount % this.recentpageplannedsize != 0) {
              console.log(
                "In iffffffffff",
                this.totalrecentCount % this.recentpageplannedsize
              );
              this.totalformsPages = this.totalformsPages + 1;a
            }

            console.log(
              "PAGES VALUEEEE",
              this.totalformsPages,
              this.totalrecentCount
            );
          } else {
            console.log("no forms found");
          }
        })

        .catch((err) => {
          console.log(err);
        });
    },
    SortSelected(sortProp, id) {
      console.log("SortPropChanged");
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        if (this.IsDesc == true) {
          if (selectedElement.classList.contains("sortDesc")) {
            return;
          } else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else if (selectedElement.classList.contains("sortAsc")) {
            return;
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.sProp = sortProp;
      this.IsDesc = this.IsDesc == true ? false : true;
    },
    SortSelect(sortProp, id) {
      console.log("SortPropChanged");
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        if (this.IsDesc == true) {
          if (selectedElement.classList.contains("sortDesc")) {
            return;
          } else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else if (selectedElement.classList.contains("sortAsc")) {
            return;
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.sProp = sortProp;
      this.IsDesc = this.IsDesc == true ? false : true;
    },
    async getpatient(siteId, index) {
      let opensites = {
        "siteId": siteId,
        "index": index
      };
      const existingIndex = this.openedsitesarray.findIndex(
        item => item.siteId === siteId && item.index === index
      );

      if (existingIndex !== -1) {
        this.openedsitesarray.splice(existingIndex, 1);
      }
      else {
        this.openedsitesarray.push(opensites);
      }
      await store.dispatch("setopenedsitesarraysubschedule", this.openedsitesarray);
      this.patientLists[index] = [];
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/management/patient/listpatient?SiteId=${siteId}&Studyid=${currentstudyid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async (res) => {
          let data = res.data.results;
          await data.forEach((patientdata) => {
            this.visitobj[patientdata.patientId] = [];
          });
          this.patientLists[index] = data;
          console.log("patient list is", this.visitobj);
        });
      // await this.setvisitobj(this.patientLists[index]);
    },
    async setvisitobj(data) {
      data.forEach((patientdata) => {
        this.visitobj[patientdata.patientId] = [];
      });
      console.log(this.visitobj);
    },
    async getVisits(patientId, index) {
      let openedvisit = {
        "patientId": patientId,
        "index": index
      }
      const existingIndex = this.openedpatientsarray.findIndex(
        item => item.patientId === patientId && item.index === index
      );

      if (existingIndex !== -1) {
        // It’s already in the array → remove it
        this.openedpatientsarray.splice(existingIndex, 1);
      } else {
        this.openedpatientsarray.push(openedvisit);
      }
      await store.dispatch("setopenedpatientarraysubschedule", this.openedpatientsarray);
      this.visitobj[patientId] = [];
      this.visitobj[patientId][index] = [];
      const idtoken = store.getters.getIdToken;
      console.log("patient ID is", patientId);

      await axios
        .get(
          `${this.baseapi}/management/patientschedule/getpatientshedule?patientID=${patientId}&ItemCount=500&sortprop=VisitNo`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.visitobj[patientId][index] = res.data.data;
          this.visitTreeObj[patientId] = this.buildVisitTree(res.data.data);
          const hasAdditional = res.data.data.some(r => r?.visitNo == null);
          console.log("hasAdditional",hasAdditional);
          this.hasadditionalforms[patientId]= hasAdditional;
          console.log("The visit list is", this.visitobj);
        })
        .catch((err) => {
          console.log("error is", err);
        });
      this.displayTable = true;
    },
    buildVisitTree(visits) {
      const tree = [];
      const cycleMap = {};
      const studyPhaseMap = {};
      const studyPhaseCycleMap = {};

      visits.forEach((visit, index) => {
        // preserve original index for side popup / activity / forms
        visit.__visitIndex = index;

        if (hasStudyPhase(visit)) {
          const key = visit.studyPhaseId || visit.studyPhase;

          if (!studyPhaseMap[key]) {
            studyPhaseMap[key] = {
              type: "studyPhase",
              studyPhase: visit.studyPhase,
              studyPhaseId: visit.studyPhaseId,
              displayText: visit.studyPhase,
              visits: []
            };
            studyPhaseCycleMap[key] = {};
            tree.push(studyPhaseMap[key]);
          }

          if (visit.isCycleVisit) {
            const cycleKey = getCycleKey(visit);

            if (!studyPhaseCycleMap[key][cycleKey]) {
              studyPhaseCycleMap[key][cycleKey] = {
                type: "cycle",
                cycleName: visit.cycleName,
                occurence: visit.occurence,
                cycleId: visit.cycleId,
                displayText: `${visit.cycleName} - ${visit.occurence}`,
                visits: []
              };
              studyPhaseMap[key].visits.push(studyPhaseCycleMap[key][cycleKey]);
            }

            studyPhaseCycleMap[key][cycleKey].visits.push(visit);
          } else {
            studyPhaseMap[key].visits.push(visit);
          }
        } else if (visit.isCycleVisit) {
          const key = getCycleKey(visit);

          if (!cycleMap[key]) {
            cycleMap[key] = {
              type: "cycle",
              cycleName: visit.cycleName,
              occurence: visit.occurence,
              cycleId: visit.cycleId,
              displayText: `${visit.cycleName} - ${visit.occurence}`,
              visits: []
            };
            tree.push(cycleMap[key]);
          }

          cycleMap[key].visits.push(visit);
        } else {
          tree.push({
            type: "visit",
            visit
          });
        }
      });

        /* ---------- SORT VISITS INSIDE EACH CYCLE ---------- */
        Object.values(cycleMap).forEach(cycle => {
          sortVisits(cycle.visits);
        });

        Object.values(studyPhaseMap).forEach(phase => {
          phase.visits.forEach(entry => {
            if (entry?.type === "cycle" && Array.isArray(entry.visits)) {
              sortVisits(entry.visits);
            }
          });
          sortStudyPhaseEntries(phase.visits);
        });

        tree.sort(compareTreeNodes);

        return tree;

        function hasStudyPhase(visit) {
          return visit?.studyPhase != null && String(visit.studyPhase).trim() !== "";
        }

        function getCycleKey(visit) {
          const cycleIdPart =
            visit.cycleId != null && visit.cycleId !== ""
              ? visit.cycleId
              : visit.cycleName || "cycle";
          return `${cycleIdPart}-${visit.occurence}`;
        }

        function sortVisits(visitList) {
          visitList.sort(compareVisits);
        }

        function sortStudyPhaseEntries(entryList) {
          entryList.sort((a, b) => {
            return compareVisits(getEntryVisit(a), getEntryVisit(b));
          });
        }

        function getEntryVisit(entry) {
          if (!entry) return null;
          if (entry.type === "cycle") {
            return Array.isArray(entry.visits) && entry.visits.length
              ? entry.visits[0]
              : null;
          }
          if (entry.type === "visit" && entry.visit) {
            return entry.visit;
          }
          return entry;
        }

        function compareVisits(a, b) {
          if (!a && !b) return 0;
          if (!a) return 1;
          if (!b) return -1;

          const dateA = getVisitSortDate(a);
          const dateB = getVisitSortDate(b);

          if (dateA && dateB) {
            const diff = dateA - dateB;
            if (diff !== 0) return diff;
          } else if (dateA && !dateB) {
            return -1;
          } else if (!dateA && dateB) {
            return 1;
          }

          const dayA = extractDay(a.visitNo);
          const dayB = extractDay(b.visitNo);

          if (dayA !== null && dayB !== null) return dayA - dayB;

          return String(a.visitNo || "").localeCompare(String(b.visitNo || ""));
        }

        function compareTreeNodes(a, b) {
          const result = compareVisits(getNodeVisit(a), getNodeVisit(b));
          if (result !== 0) return result;

          const rankA = getNodeRank(a);
          const rankB = getNodeRank(b);
          if (rankA !== rankB) return rankA - rankB;

          return String(getNodeLabel(a)).localeCompare(String(getNodeLabel(b)));
        }

        function getNodeVisit(node) {
          if (!node) return null;
          if (node.type === "visit") return node.visit || null;
          if (node.type === "cycle") {
            return Array.isArray(node.visits) && node.visits.length
              ? node.visits[0]
              : null;
          }
          if (node.type === "studyPhase") {
            return Array.isArray(node.visits) && node.visits.length
              ? getEntryVisit(node.visits[0])
              : null;
          }
          return null;
        }

        function getNodeRank(node) {
          if (!node) return 99;
          if (node.type === "studyPhase") return 0;
          if (node.type === "visit") return 1;
          if (node.type === "cycle") return 2;
          return 99;
        }

        function getNodeLabel(node) {
          if (!node) return "";
          if (node.type === "studyPhase") return node.studyPhase || "";
          if (node.type === "visit") {
            const visit = node.visit || {};
            return `${visit.visitNo || ""}-${visit.visitName || ""}`;
          }
          if (node.type === "cycle") return node.displayText || node.cycleName || "";
          return "";
        }

      /* ---------- HELPERS ---------- */
        function extractDay(visitNo) {
          const match = visitNo?.match(/D(\d+)/i);
          return match ? parseInt(match[1], 10) : null;
        }

        function getVisitSortDate(visit) {
          if (!visit) return null;
          const raw =
            visit.visitStatus === "Completed" || visit.visitStatus === "In Progress"
              ? visit.actualVisitStartDate
              : visit.visitDate;
          if (!raw) return null;
          const dt = new Date(raw);
          return isNaN(dt.getTime()) ? null : dt;
        }
      },
    loadTemplate: function (page) {
      this.currentTemplatePage = page;
      this.getForms();
    },
    async listTemplate() {
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&Status=Approved&StudyID=${currentstudyid}&&SortProperty=templateName&SortOrder=0 `,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("Study template list is...", res.data);
          this.templateList = res.data.results;
        })
        .catch((err) => console.log("error while getting template list", err));
    },
    toggleSidePopup(sIndex, pIndex, vIndex) {
      console.log("Toggle", sIndex, this.showSidePopup);

      // Initialize arrays if they don't exist
      if (!this.showSidePopup[sIndex]) {
        this.showSidePopup[sIndex] = [];
      }
      if (!this.showSidePopup[sIndex][pIndex]) {
        this.showSidePopup[sIndex][pIndex] = [];
      }

      // Toggle the value
      if (typeof this.showSidePopup[sIndex][pIndex][vIndex] === "undefined") {
        this.showSidePopup[sIndex][pIndex][vIndex] = false;
      }
      this.showSidePopup[sIndex][pIndex][vIndex] = !this.showSidePopup[sIndex][
        pIndex
      ][vIndex];
    },
    closeSidePopup(sIndex, pIndex, vIndex) {
      if (this.showSidePopup[sIndex] && this.showSidePopup[sIndex][pIndex]) {
        this.showSidePopup[sIndex][pIndex][vIndex] = false;
      }
    },
    activityInputId(sa, patient, visit) {
    return `act-${sa.activityId}-${patient}-${visit.visitNo}-${sa.activityOrder}`;
  },
   formInputId(singlevisit, pIndex, vIndex, activityindex) {
    return `form-${singlevisit.sheduleId}-${pIndex}-${vIndex}-${activityindex}`;
  },
    async openModal(visit, subjectId, siteCode, visitstatus) {
      if (visit.withdrawnDate) {
        alert("You cannot add new forms to a withdrawn visit");
      } else {
        console.log("Open Modal", visit, subjectId, siteCode);
        this.selectedVisit.visit = visit;
        this.selectedVisit.subjectId = subjectId;
        this.selectedVisit.siteCode = siteCode;
        console.log("selected visit is ", this.selectedVisit);
        // this.selectedmodeltemplate = "";
        // this.selectedvisitid = visitid;
        await this.listTemplate();
        const modalWrapper = document.querySelector(".modal-wrapper");
        if (modalWrapper) {
          modalWrapper.classList.add("active");
        }
     
      }
    },
    closeModal() {
      // this.selectedmodeltemplate = "";
      const modalWrapper = document.querySelector(".modal-wrapper");
      if (modalWrapper) {
        modalWrapper.classList.remove("active");
      }
    },
    closeSdvModal() {
  this.showSdvModal = false;
},

    async getAdditionalForms(subjectId) {
      if(this.additionalformchecked[subjectId]){
        this.additionalformchecked[subjectId] = !this.additionalformchecked[subjectId];
      }
      else{
        this.additionalformchecked[subjectId] = true;
      }
      const idtoken = this.$store.getters.getIdToken;
      const stdid = this.$store.getters.getStudyIs;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/patientschedule/getfromsbyvisit`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
            params: {
              studyId: stdid,
              patientID: subjectId,
              visitNo: null,
            },
          }
        );
        // Vue reactivity: use Vue.set or assign directly if using Vue 3
        this.additionalFormObj[subjectId] = res.data.data;
        
        console.log("data is ", this.additionalFormObj[subjectId]);
      } catch (err) {
        console.log("error while getting visit forms list", err);
      }
    },
    async getFormsByVisit(
  subjectId,
  visitNo,
  visitName,
  visitIndex,
  sheduleId,
  activityindex,
  activityid,
  activityorder
) {
  // (unchanged) toggle checkbox safely
  if (activityid != null && activityorder != null) {
    const cbId = `${activityid}${subjectId}${visitNo}${activityorder}`;
    const el = document.getElementById(cbId);
    if (el) el.checked = !el.checked;
  }

  // (unchanged) persist open state
  const opened = { sheduleId, subjectId, visitNo, visitName, visitIndex };
  if (activityid != null && activityorder != null) {
    opened.activityid = activityid;
    opened.activityorder = activityorder;
  }
  const existingIndex = this.openedformsarray.findIndex(item =>
    item.sheduleId === sheduleId &&
    item.subjectId === subjectId &&
    item.visitNo === visitNo &&
    item.visitName === visitName &&
    item.visitIndex === visitIndex &&
    (
      (opened.activityid == null && item.activityid == null) ||
      (opened.activityid != null &&
       item.activityid === opened.activityid &&
       item.activityorder === opened.activityorder)
    )
  );
  if (existingIndex !== -1) this.openedformsarray.splice(existingIndex, 1);
  else this.openedformsarray.push(opened);
  await store.dispatch("setopenedformsarraysubschedule", this.openedformsarray);

  // (unchanged) data prep
  const key = visitNo + subjectId;
  if (!this.visitFormObj[key]) this.visitFormObj[key] = [];
  if (activityindex == null && activityid != null) {
    activityindex = this.findActivityIndex(subjectId, visitNo, visitIndex, activityid, activityorder);
    if (activityindex < 0) activityindex = 0;
  }
  if (activityindex == null) activityindex = 0;
  this.visitFormObj[key][activityindex] = [];

  // --- CHANGED PART: build request without `??` and without manual string concat
  const idtoken = store.getters.getIdToken;
  const stdid = store.getters.getStudyIs;

  try {
    const res = await axios.get(
      `${this.baseapi}/management/patientschedule/getfromsbyvisit`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
        params: {
          studyId: stdid,
          patientID: subjectId,
          visitNo: visitNo,
          visitName: visitName,
          activityId: activityid == null ? "" : activityid,
          activityOrder: activityorder == null ? "" : activityorder,
        },
      }
    );
    this.visitFormObj[key][activityindex] = res.data.data;
    console.log("data is ", this.visitFormObj[key][activityindex]);
  } catch (err) {
    console.log("error while getting visit forms list", err);
  }
},
    async getactivities(subjectId, visitNo, visitName, visitIndex, sheduleId, patientNo) {
      const visitKey = `${visitNo}_${subjectId}`;
      this.subjectIdSelected = subjectId;
      const openedforms = { sheduleId, subjectId, visitNo, visitName, visitIndex };

      const existingIndex = this.openedformsarray.findIndex(
        item => item.sheduleId === sheduleId && item.subjectId === subjectId &&
          item.visitNo === visitNo && item.visitName === visitName &&
          item.visitIndex === visitIndex
      );

      if (existingIndex !== -1) {
        this.openedformsarray.splice(existingIndex, 1);
      } else {
        this.openedformsarray.push(openedforms);
      }

      await store.dispatch("setopenedformsarraysubschedule", this.openedformsarray);
      this.visitIndex = visitIndex;

      if (!this.activityobject[visitKey]) {
        this.activityobject[visitKey] = [];
      }

      this.observationValue[visitKey] = false;
      this.activityobject[visitKey][visitIndex] = [];

      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/patientschedule/getactivitynames?subjectId=${subjectId}&visitNo=${visitNo}&studyId=${currentstudyid}`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.activityobject[visitKey][visitIndex] = res.data.data;
       console.log("this.activityobject[visitKey][visitIndex]",this.activityobject);
      } catch (err) {
        console.error("Error while getting visit forms list", err);
      }
    },
    
    async listVisitForms(siteId, subjectId, visitNo) {
      this.visitFormObj[visitNo] = [];
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/forms/forms/getformsbyids?studyid=${stdid}&siteid=${siteId}&subjectid=${subjectId}&visitno=${visitNo}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.visitFormObj[visitNo] = res.data;
          console.log("Visit form list is...", this.visitFormObj);
          console.log("data is ", this.visitFormObj[visitNo]);
        })
        .catch((err) =>
          console.log("error while getting visit forms list", err)
        );
    },
    selectDocument(siteCode, patientId, doc, visitName, subjectId, siteId) {
      sessionStorage.setItem("FHIRpatient", JSON.stringify(doc));
      this.$router.push(
        `/FHIRpage/${siteCode}/${patientId}/${visitName}/${subjectId}/${siteId}`
      );
    },
    filterTimeFormat(data) {
      if (data) {
        return data.replace(/:00\+00:00$/, "");
      }
    },
    async toggleObservationFolder(
      siteCode,
      subjectCode,
      visitCode,
      visitNo,
      patientId
    ) {

      await axios
        .get(
          `${this.baseapi}/fhir-service/fhir/observations?StudyRef=${this.studyRef}&SiteCode=${siteCode}&Subjects=${subjectCode}&VisitCodes=${visitCode}`
        )
        .then((res) => {
          if (res.data && res.data.length != 0 && res.data != 'Visits Not Found') {
            this.observationValue[visitNo + patientId] = true
            this.categoryFlags[visitNo + patientId] = Object.values(
              res.data.reduce((acc, doc) => {
                const document = doc.resource;
                const id = doc.resource.id;
                const category = doc.resource.category[0].coding[0].display;
                const codeText = doc.resource.code.text
                  ? doc.resource.code.text
                  : doc.resource.code.coding[0].display; // Handle missing `text`
                const effectiveDateTime = doc.resource.effectiveDateTime || null;

                // If the category already exists, add the code to its array
                if (!acc[category]) {
                  acc[category] = {
                    category: category,
                    code: [],
                    effectiveDateTime: [],
                    flag: false,
                    document: [],
                    id: [],
                    idSet: new Set(), // Track unique IDs
                  };
                } // Push codeText to the array (allowing duplicates)
                if (id && !acc[category].idSet.has(id)) {
                  acc[category].idSet.add(id);
                  acc[category].id.push(id);

                  if (codeText) {
                    acc[category].code.push(codeText);
                  }
                  if (effectiveDateTime) {
                    acc[category].effectiveDateTime.push(effectiveDateTime);
                  }
                  if (document) {
                    acc[category].document.push(document);
                  }
                }

                return acc;
              }, {})
            );
            const vitalSignsCategory = this.categoryFlags[
              siteCode + subjectCode
            ].find(
              (category) =>
                category.category === "Vital Signs" ||
                category.category === "vital signs"
            );
            let latestVitalSigns = [];

            if (vitalSignsCategory) {
              const {
                code,
                document,
                unit,
                effectiveDateTime,
              } = vitalSignsCategory;

              // Combine code and effectiveDateTime into a single array of objects
              const combined = code.map((c, index) => ({
                code: c,
                value:
                  c == "Blood Pressure"
                    ? `${document[index].component[1].valueQuantity.value}/${document[index].component[2].valueQuantity.value}`
                    : c == "Body height" ||
                      c == "Body weight" ||
                      c == "Body Temperature"
                      ? document[index].valueQuantity.value
                      : "",
                unit:
                  c == "Blood Pressure"
                    ? document[index].component[1].valueQuantity.unit
                    : c == "Body height" ||
                      c == "Body weight" ||
                      c == "Body Temperature"
                      ? document[index].valueQuantity.unit
                      : "",
                effectiveDateTime: effectiveDateTime[index], // Convert to Date for sorting
              }));
              // Sort by effectiveDateTime in descending order
              combined.sort((a, b) => b.effectiveDateTime - a.effectiveDateTime);

              // Extract the latest unique code entries
              const seenCodes = new Set();
              const latestVitalSigns = combined
                .filter((entry) => {
                  if (!seenCodes.has(entry.code)) {
                    seenCodes.add(entry.code);
                    return true;
                  }
                  return false;
                })
                .map((entry) => ({
                  code: entry.code,
                  value: entry.value,
                  unit: entry.unit,
                  effectiveDateTime: entry.effectiveDateTime, // Convert back to string if needed
                }));
              this.vitalSignsList = latestVitalSigns;
            }
          }
          else {
            this.observationValue[visitNo + patientId] = false
          }

        })
        .catch((err) => {
          console.log("Error", err);
        });
    },
    async closePopover(id) {
      document.getElementById(id)
        ? document.getElementById(id).hidePopover()
        : null;
    },
    async openChangeStatusmodalforactivity(
      actScheduleId,
      status,
      patientId,
      visitNo,
      visitName,
      vIndex,
      sheduleId,
      popoverId
    ) {
      await this.closePopover(popoverId);
      this.activitystatusreload.patientId = patientId;
      this.activitystatusreload.visitNo = visitNo;
      this.activitystatusreload.visitName = visitName;
      this.activitystatusreload.sheduleId = sheduleId;
      this.activitystatusreload.vIndex = vIndex;
      this.selectedActivityid = actScheduleId;
      this.currentactivitystatus = status;
      this.showChangeActivity = true;
    },
    async closeChangeactivityModal() {
      this.showChangeActivity = false;
    },
    async closeAssignSdvModal() {
      this.showSdvModal = false;
    },
    async changedactivityStatus(activitystatusreload){
      this.getactivities(
                                activitystatusreload.patientId,
                                activitystatusreload.visitNo,
                                activitystatusreload.visitName,
                                activitystatusreload.vIndex,
                                activitystatusreload.sheduleId,
                              );
          this.showChangeActivity = false;
    },
    async assignSdv( formId, templateId, popoverId) {
      // Set modal props and open the Assign SDV modal
      await this.closePopover(popoverId);
      this.selectedForm = formId || null;
      this.templateIdForSdv = templateId || null;
      console.log("Assign SDV modal opened with:",formId);
      this.showSdvModal = true;
    },
    async closeManageVisitModal(){
this.ManageVisitPopup = false;
    },
    async closeplannextvisitModal(){
      this.plannextvisitPopup = false;
    },
    getVisitIdentity(visit) {
      if (!visit) return null;
      if (visit.sheduleId != null) return `sid:${visit.sheduleId}`;
      if (visit.visitId != null) return `vid:${visit.visitId}`;
      return `v:${visit.visitNo || ""}|${visit.visitName || ""}|${visit.patientId || ""}`;
    },
    getNestedNodeIndex(parentIndex, childIndex) {
      return `${parentIndex}-${childIndex}`;
    },
    getFlattenedSortedVisits(patientId) {
      const tree = this.visitTreeObj?.[patientId] || [];
      const flattened = [];

      tree.forEach((node) => {
        appendNodeVisits(node);
      });

      return flattened;

      function appendNodeVisits(node) {
        if (!node) return;

        if (node.type === "visit" && node.visit) {
          flattened.push(node.visit);
          return;
        }

        if ((node.type === "cycle" || node.type === "studyPhase") && Array.isArray(node.visits)) {
          node.visits.forEach((entry) => {
            if (!entry) return;

            if (entry.type === "cycle") {
              appendNodeVisits(entry);
              return;
            }

            if (entry.type === "visit" && entry.visit) {
              flattened.push(entry.visit);
              return;
            }

            flattened.push(entry);
          });
        }
      }
    },
    getNextSortedVisit(patientId, currentVisit) {
      const flattened = this.getFlattenedSortedVisits(patientId);
      if (!flattened.length || !currentVisit) return null;

      const currentKey = this.getVisitIdentity(currentVisit);
      const idxByKey = flattened.findIndex((v) => this.getVisitIdentity(v) === currentKey);
      const index = idxByKey >= 0 ? idxByKey : flattened.findIndex((v) => v === currentVisit);
      if (index < 0 || index >= flattened.length - 1) return null;

      return flattened[index + 1] || null;
    },
    hasNextSortedVisit(patientId, currentVisit) {
      return !!this.getNextSortedVisit(patientId, currentVisit);
    },
    formatDateTimeForInput(value) {
      if (!value) return null;
      const formatted = moment(value).utc().format("YYYY-MM-DDTHH:mm");
      return formatted === "Invalid date" ? null : formatted;
    },
    async openPlanNextVisitModal(patientId, currentVisit){
      this.oldvisitdatetDate = "";
      this.newvisitDate = "";
      this.preVisitDate = "";
      this.postVisitDate = "";
      const nextVisit = this.getNextSortedVisit(patientId, currentVisit);
      if (!nextVisit) return;

      this.createvisitobj = nextVisit;
      this.oldvisitdatetDate = this.formatDateTimeForInput(nextVisit.visitDate);
      console.log("next visit object is ", nextVisit);
      this.plannextvisitPopup = true;
    },
    async changeVisitDate() {
      const schedules = this.visitobj[this.createvisitobj.patientId][0] || []

      const selectedSchedule = schedules.find(
        s => s.visitName === this.createvisitobj.visitName
      )
      if (selectedSchedule?.visitDate) {
        this.oldvisitdatetDate = this.formatDateTimeForInput(selectedSchedule.visitDate);
      }
    },
    async Createnewvisitfun(payload){
      if (!this.newvisitDate) {
        alert("Please enter New Visit Date");
        return; // API call
      }
      this.showLoader = true;
      const idtoken = store.getters.getIdToken;
         try {
      const res = await axios.put(
       `${this.baseapi}/management/patientschedule/activatenextvisit`,
      {
        studyId: payload.studyId,
        subjectId: payload.patientId,
        visitNumber: payload.visitNo,        
        oldVisitDate: this.oldvisitdatetDate,
        newVisitDate: this.newvisitDate,
        preVisitDate:this.preVisitDate || null,
        postVisitDate:this.postVisitDate || null
      },
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    alert("Updated Successfully");
    this.showLoader = false;
    return res.data;
  } catch (err) {
    console.log(err);
    alert("Something went wrong");
    this.showLoader = false;
    throw err;
  } finally {
    this.plannextvisitPopup = false;
    await this.getVisits(this.subjectId, 0);
    this.showLoader = false;
  }
    },
    async openchangeplanneddatePopup(visitobj){
      this.plannedvisitobject = visitobj;
      this.plannedvisitpopup = true;
    },
    async openManageVisitPopup(visitobj){
      console.log("visit object is ",visitobj);
      this.isCompleted == false;
      if(visitobj.actualVisitStartDate==null || visitobj.actualVisitStartDate==""){
        this.actualVisitStartDate = "";
      }
      else{
        this.actualVisitStartDate = this.formatDateTimeForInput(visitobj.actualVisitStartDate);

      }
     
      if(visitobj.actualVisitEndDate==null || visitobj.actualVisitEndDate==""){
        this.actualVisitEndDate = "";
      }
      else{
        this.actualVisitEndDate = this.formatDateTimeForInput(visitobj.actualVisitEndDate);
      }
      


      if(visitobj.visitStatus == "Completed"){
        this.isCompleted == true;
      }
      this.managevisitobj = visitobj;
      this.ManageVisitPopup = true;
    },
    async updateactualvisitdates(payload) {
      if(this.actualVisitStartDate == ""){
        alert("Please enter Visit Start Date");
        return
      }
      this.showCreateLoader = true;
      let actualVisitEndDate = this.actualVisitEndDate;
      if(actualVisitEndDate == ""){
        actualVisitEndDate = null;
      }
  const idtoken = store.getters.getIdToken;
  const formattedActualVisitStartDate = this.formatDateTimeForInput(this.actualVisitStartDate) || this.actualVisitStartDate;
  const formattedActualVisitEndDate = actualVisitEndDate
    ? (this.formatDateTimeForInput(actualVisitEndDate) || actualVisitEndDate)
    : null;

  try {
    const res = await axios.put(
      `${this.baseapi}/management/patientschedule/updateactualvisitdates`,
      {
        studyId: payload.studyId,
        subjectId: payload.patientId,
        visitNumber: payload.visitNo,
        plannedVisitDate: payload.visitDate,          
        actualVisitStartDate: formattedActualVisitStartDate,
        actualVisitEndDate: formattedActualVisitEndDate,
        isCompleted: this.isCompleted,
      },
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    if (res && res.data === "Template Not Found") {
      alert("Template Not Found");
      this.showCreateLoader = false;
      return;
    }

    alert("Updated Successfully");
    return res.data;
  } catch (err) {
    console.log(err);
    alert("Something went wrong");
    this.showCreateLoader = false;
    throw err;
  } finally {
    this.showCreateLoader = false;
    this.ManageVisitPopup = false;
    await this.getVisits(this.subjectId, 0);
  }
},
setdate(visitobj){
  let datereturn = "";
  if(visitobj.visitStatus=="Completed" || visitobj.visitStatus=="In Progress"){
  datereturn = this.filter(visitobj.actualVisitStartDate)
  }
  else{
datereturn = this.filter(visitobj.visitDate);
  }
 
return datereturn;
},
    async openChangeStatusmodal(
      studyId,
      visitNo,
      patientId,
      status,
      index,
      statusType,
      id,
      visitName,
      formStatus,
      formId,
      scheduleId
    ) {
      await this.closePopover(id);
      this.selectedForm = formId;
      this.scheduleId = scheduleId;
      this.statusType = statusType;
      this.changeStatus = {
        studyId: studyId,
        visitNo: visitNo,
        subjectId: patientId,
        visitstatus: statusType == "Visit" ? status : formStatus,
      };
      this.formIndex = index;
      this.selectedVisitName = visitName;
      this.visitIndex = index;
      this.showChangeSchedule = true;
    },
    closeModalchangetemolate() {
      this.showChangeTemplateModal = false;
    },
    async ChangeTemplatePopup(
      studyId,
      visitNo,
      patientId,
      status,
      index,
      statusType,
      popoverId,
      visitName,
      formStatus,
      scheduleId,
      templateId
    ) {
      await this.closePopover(popoverId);
      await this.listTemplate();
      this.selectedVisitName = visitName;

      this.changetemplateobj = {
        studyId: studyId,
        visitNo: visitNo,
        subjectId: patientId,
        visitstatus: statusType == "Visit" ? status : formStatus,
      };

      this.visitIndex = index;
      this.selectedScheduleId = scheduleId;

      // if (templateId && this.templateList.some(t => t.templateId === templateId)) {
      // this.selectedTemplate = templateId;
      if (templateId != null && templateId != "null" && templateId != undefined) {
        this.temptemplatelist = this.templateList.filter(t => t.templateId != templateId);
        this.selectedTemplate = templateId;
      } else {
        this.selectedTemplate = "";
      }

      this.showChangeTemplateModal = true;
    },

    async assignTemplate() {
      if (!this.selectedTemplate) {
        alert(this.$t('navigations.please select a form'));
        return;
      }
      const idtoken = store.getters.getIdToken;
      try {
        await axios.put(
          `${this.baseapi}/management/patientschedule/templateupdate?TemplateId=${this.selectedTemplate}&SheduleID=${this.selectedScheduleId}`, {},
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        ).then((res) => {
          if (res.data === "Template Not Found") {
            alert(this.$t("navigations.template not found"));
          } else {
            alert(this.$t('navigations.template assigned successfully'))
          }
        });
        this.selectedTemplate = "";
        this.showChangeTemplateModal = false;
        await this.getFormsByVisit(
          this.changetemplateobj.subjectId,
          this.changetemplateobj.visitNo,
          this.selectedVisitName,
          this.visitIndex
        );
        // Refresh forms for the updated schedule
        // Refresh forms for the updated schedule
        // if (

        //   this.selectedVisit &&
        //   this.selectedVisit.visit &&
        //   this.selectedVisit.subjectId &&
        //   this.selectedVisit.visit.visitNo &&
        //   this.selectedVisit.visit.studyId
        // ) {
        //   await this.getFormsByVisit(
        //     this.selectedVisit.subjectId,
        //     this.selectedVisit.visitNo,
        //     this.selectedVisitName,

        //   );
        // } else {
        //   // fallback: reload the page if visit info is not available
        //   // window.location.reload();
        // }
      } catch (err) {
        alert(err);
      }
    },
    async closeChangeScheduleModal() {
      this.showChangeSchedule = false;
    },
    popoverId(svisit, sIndex, pIndex, vIndex) {
      return `${svisit}-${sIndex}-${pIndex}-${vIndex}`;
    },
    async changedStatus() {
      console.log("inside change status", this.statusType);
      if (this.statusType == "Visit") {
        await this.getVisits(this.subjectId, this.visitIndex);
      } else {
        await this.getVisits(this.subjectId, this.visitIndex);
        await this.getFormsByVisit(
          this.changeStatus.subjectId,
          this.changeStatus.visitNo,
          this.selectedVisitName,
          this.visitIndex
        );
      }
    },
    async getEPROFormsList() {
      const idtoken = store.getters.getIdToken;
      const currentstudy = await store.getters.getStudyIs;
      await axios
        .get(`${this.baseapi}/management/epro/ecrfformslist?studyId=${currentstudy}&category=ePRO`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data) {
            this.ecrfformlist = response.data.entities;
          } else {
            console.log("No ePRO forms found");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async saveForm(forms) {
      const idtoken = store.getters.getIdToken;
      try {
        if ((forms.useDate && forms.useRecurrence) || (!forms.useDate && !forms.useRecurrence)) {
          alert("Please choose either 'Select Date' or 'Recurrence Cycle'.");
          return;
        }
        if (forms.useDate) {
          if (!forms.selectedDate) {
            alert("Please select a date.");
            return;
          }
        }
        if (forms.useRecurrence) {
          if (!forms.selectedRecurrence) {
            alert("Please select a recurrence cycle.");
            return;
          }
          if (!forms.recurrenceFromDate) {
            alert("Please select a from date.");
            return;
          }
          if (!forms.occurrence || forms.occurrence < 1) {
            alert("Please enter a valid occurrence (min 1).");
            return;
          }
        }
        this.referanceType = "";
        this.occuranceStartDate = "";
        this.totalOccurance = "";
        if (forms.useDate) {
          this.occuranceStartDate = forms.selectedDate;
          this.totalOccurance = 1;
          this.referanceType = "Daily";
        } else if (forms.useRecurrence) {
          this.referanceType = forms.selectedRecurrence;
          this.occuranceStartDate = forms.recurrenceFromDate;
          this.totalOccurance = forms.occurrence;
        }

        this.templateName = forms.templateName;
        this.templateId = forms.template_ID;

        const response = await axios.post(
          `${this.baseapi}/management/patientschedule/eprooccurrenceforms?SubjectId=${this.selectedPatientId}&ReferanceType=${this.referanceType}&OccuranceStartDate=${this.occuranceStartDate}&VisitName=${this.selectedVisitName}&TotalOccurance=${this.totalOccurance}&TemplateName=${this.templateName}&TemplateId=${this.templateId}&visitType=Subject%20Visit`,
          {},
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        alert(this.$t("navigations.epro forms assigned successfully"));
        this.referanceType = "";
        this.occuranceStartDate = "";
        this.totalOccurance = "";
        this.templateName = "";
        this.templateId = "";
        if (forms.useDate) {
          forms.selectedDate = "";
          forms.useDate = false;
        }
        if (forms.useRecurrence) {
          forms.selectedRecurrence = "";
          forms.recurrenceFromDate = "";
          forms.occurrence = "";
          forms.useRecurrence = false;
        }
        console.log("API Response:", response.data);
      } catch (error) {
        console.error("Error calling ePRO occurrence forms API:", error);
      }
    },
    async getSubjectTemplates(){
      const currentstudyid = store.getters.getStudyIs;
      try{
        var result = await axios.get(`${this.baseapi}/forms/template/listtemplate?TemplateName=${this.selectedFormScope}&FormScope=Subject Level&StudyID=${currentstudyid}`,
                        {
                          headers: {
                            Authorization: "Bearer " + this.$store.getters.getIdToken,
                            "Content-Type": "application/json",
                          },
                        }
                    );
        this.subjectTemplates = result.data.results;
        console.log("Subject templates......!", this.subjectTemplates);
      }
      catch(err){
        console.log("Error while fetching subject templates", err);
      }
    },
    loadPage: function (page) {
      this.currentoverduePage = page;
      this.pageoverdueindex = this.currentoverduePage;
    },
    loadPlanned: function (page) {
      this.currentplannedPage = page;
      this.pageplannedindex = this.currentplannedPage;
    },
    loadForm: function (page) {
      this.currentformPage = page;
      this.pageformindex = this.currentformPage;
      this.getForms();
    },
    loadrecentForm: function (page) {
      this.currentRecentformPage = page;
      this.recentpageformindex = this.currentRecentformPage;
      this.GetRecentFormData();
    },
     openManageVisitPopupNew(item){
      console.log("manage visit item is ", item);
      this.managevisitobj = item;
      this.showManageVisitModal = true;
    },
    closeManageVisitModalNew(){
      this.showManageVisitModal = false;
    },
     openUnscheduledVisitModal(item){
      console.log("unscheduled visit item is ", item);
      this.patientId = item.patientId;
      this.showUnscheduledVisitModal = true;
    },
    closeUnscheduledVisitModal(){
      this.showUnscheduledVisitModal = false;
    },
    async refreshVisits(){
      await this.getVisits(this.subjectId, 0);
    }
    
  },
};
